import { render, staticRenderFns } from "./ClientProjectEnvironmentDropdown.vue?vue&type=template&id=7025f479&"
import script from "./ClientProjectEnvironmentDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClientProjectEnvironmentDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports